import { Box, Button, styled } from '@mui/material'

export const HeaderButton = styled(Button)(({ theme }) => ({
  // backgroundColor: theme.palette.mode === 'dark' ? 'rgb(51, 67, 91)' : 'rgb(211, 211, 211)',
  backgroundColor: 'rgb(29, 106, 82)',
  color: theme.palette.mode === 'dark' ? 'white' : 'white',
}))
export const headerStyle = theme => ({
  fontWeight: 'bold',
  fontSize: 20,
  color: theme.palette.mode === 'dark' ? 'white' : 'black',
})
export const StickyHeader = styled(Box)(({ theme }) => ({
  position: 'sticky',
  top: 0,
  zIndex: 2,
  backgroundColor: 'bnackground.paper',
  boxShadow: '0px 2px 4px rgba(0,0,0,0.1)',
  padding: '16px',
  borderBottom: `1px solid`,
  borderColor: 'background.divider',
}))
